import { CalendarPlusIcon } from '@phosphor-icons/react';

import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const CalendarAdd = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return <CalendarPlusIcon {...rest} size={Sizes[size]} color={fill} />;
};

CalendarAdd.displayName = 'CalendarAdd';
